/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Approve_LabelInputs */



/**
* | output |
* | --- |
* | "Approve selected events" |
*
* @param {Context_Menu_Approve_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_approve_label = /** @type {((inputs?: Context_Menu_Approve_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Approve_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Approuver les événements sélectionnés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Genehmigen Sie ausgewählte Ereignisse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Approva gli eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Одобрить выбранные события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aprobar eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("批准选定事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントを承認する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटनाओं को अनुमोदित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aprovar eventos selecionados")
	return /** @type {LocalizedString} */ ("Approve selected events")
});